module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloud#2-b75a8364de7a6d99fdb9f336cd54ccf5.svg";